<template>
  <div class="ma-3">
    <h1 style="font-size: xx-large;margin-top: 80px; line-height: 35px; font-weight: bold;"
      :style="{ color: $ajustes.colorTexto2 }">NOTICIAS Y NOVEDADES</h1>
    <h1 style="font-size:large; line-height: 35px; font-weight: normal;" :style="{ color: $ajustes.colorTexto2 }">
      Conoce nuestros eventos mas importantes</h1>
    <v-row class="pt-2 center" v-if="noticias.length > 0">
      <v-col class="ma-0 pa-2" v-for="noticia in noticiasHabilitadas" :key="noticia.id" lg="3" md="4" sm="6" cols="12">
        <v-container class="pa-1" style="overflow: hidden; align-items: center;align-items: center;">
          <noticia :propNoticia="noticia" />
        </v-container>
      </v-col>
    </v-row>
    <h2 v-else class="center">
      <br>
      {{ datosMensaje }}
    </h2>
  </div>
</template>

<script>
import axios from 'axios';
import noticia from "@/components/template/noticia";

export default {
  components: {
    noticia
  },
  metaInfo() {
    return {
      title: "Noticias y Novedades",
      titleTemplate: "%s | INSEG",
      meta: [
        {
          name: "description",
          content: "Últimas noticias y novedades sobre formación técnica y profesional en Seguridad Global y Transporte, INSEG Ecuador."
        }
      ]
    }
  },
  data() {
    return {
      datosMensaje: "Buscando...",
      noticias: [],
      showMenu: true,
      show: {
        responsible: "",
      },

    };
  },
  mounted() {
    this.obtenerNoticias()
  },
  created() {

  },
  methods: {

    async obtenerNoticias() {
      await axios.get("/obtener_noticias")
        .then((response) => {
          if (response) {
            this.noticias = response.data.data
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        })
        .catch(() => {
          this.datosMensaje = "No hay cursos disponibles"

        });
      this.loading = false
    },

  },
  computed: {
        noticiasHabilitadas() {
      return this.noticias.filter(noticia => noticia.habilitado);
    },
  },
  beforeDestroy() {
  },
};
</script>

<style scoped>
.centered-input>>>input {
  text-align: center;
}
</style>